/* this file added by Bearer Web Developer  */
import React from 'react';
import styles from './dataNumber.module.scss';
import { useAppState } from '../../../../states/app-state';
import { useThemeMode } from '../../../../states/contexts/theme';

const DataNumber: React.FC = () => {
    const appState = useAppState();
    const activeManageOrder = appState?.ReservedOrders?.activeManageOrder;
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    const { earliest_pickup_time, is_time_sensitive_order } = activeManageOrder!;
    const earliest = earliest_pickup_time && is_time_sensitive_order;
    return (
        <div className={`${styles.data_number} ${earliest ? styles.data_number_earliest : ''}`} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <span>BRN: </span>
            {
                theme === 'dark' ? <img src="/help-white.svg" alt="" width={15} height={15} /> :
                    <img src="/help-grey.webp" alt="" width={18} height={18} />
            }
            <span>{activeManageOrder?.order_number}</span>
        </div>
    )
}
export default DataNumber;